import React, { useState, useContext } from 'react';
import { CommentsContext } from '../../../context/CommentsContext';
import Emoji from '../emoji';

import style from './style.module.scss';
import cn from 'classnames';

function Input() {
  const [focusActive, setFocusActive] = useState(false);
  const { input, setInput, handleSubmit } = useContext(CommentsContext);

  return (
    <div className={cn(style.wrapper, { [style.focus]: focusActive })}>
      <textarea
        className={style.textarea}
        onFocus={e => setFocusActive(true)}
        onBlur={e => setFocusActive(false)}
        value={input}
        onInput={e => setInput(e.target.value)}
        placeholder="Escreva um comentário"
      ></textarea>
      <div className={style.btnsContainer}>
        <Emoji />

        <button
          className={style.submit}
          onClick={e => handleSubmit()}
        >
          Publicar
        </button>
      </div>
    </div>
  );
}

export default Input;
